// extracted by mini-css-extract-plugin
export default {"fs":"f58b31890a _097f6f6c36"};